import { Coffee, ShoppingBasket, Snowflake, type LucideIcon } from "lucide-react";

/**
 * Os três bônus da VSL v1.2 (bloco 16). O valor dito na VSL fica aqui só
 * como registro — o app não mostra preço (decisão do dono).
 *
 * Nenhum é texto: Coffee Bar é uma grade de 20 receitas (tag coffee-bar);
 * Grocery Shortlist é uma lista estruturada por loja com "add to list";
 * Make-Ahead Sunday é o plano do domingo (tag make-ahead-sunday) com
 * checklist e "add everything to my list".
 */
export type BonusCEM = {
  slug: "coffee-bar" | "grocery-shortlist" | "make-ahead-sunday";
  titulo: string;
  /** Uma linha, para listas. */
  subtitulo: string;
  /** A frase da VSL, para o topo da página do bônus. */
  descricao: string;
  icone: LucideIcon;
};

export const BONUS_CEM: BonusCEM[] = [
  { slug: "coffee-bar", titulo: "The Coffee Bar", subtitulo: "Coffees and creamers, no sugar", descricao: "Twenty coffees and creamers with no sugar in them — the four-dollar bottle from the aisle, made at home.", icone: Coffee },
  { slug: "grocery-shortlist", titulo: "The Grocery Shortlist", subtitulo: "What to buy, by store and brand", descricao: "What to buy, by store and by brand — and the five things to walk straight past.", icone: ShoppingBasket },
  { slug: "make-ahead-sunday", titulo: "Make-Ahead Sunday", subtitulo: "Make it once, eat it all week", descricao: "Twelve breakfasts and twelve snacks you make once on Sunday and eat all week.", icone: Snowflake },
];

export const bonusCEM = (slug?: string) => BONUS_CEM.find((b) => b.slug === slug) ?? null;
